import { useCallback, useEffect, useLayoutEffect, useRef, useState } from 'react';

import {
  IoBriefcaseOutline,
  IoCashOutline,
  IoChevronDownOutline,
  IoCheckmarkOutline,
  IoFlashOutline,
  IoKeyOutline,
  IoLocationOutline,
  IoMailOutline,
  IoPeopleOutline,
  IoSearchOutline,
} from 'react-icons/io5';

import newLogoSm from '../../../assets/nav/new-logo-sm-2.svg';

import {
  AiSequenceAvatar,
  AiSequenceBubble,
  AiSequenceCanvas,
  AiSequenceCaret,
  AiSequenceCfg,
  AiSequenceCfgField,
  AiSequenceCfgLabel,
  AiSequenceCfgTab,
  AiSequenceCfgTabs,
  AiSequenceCfgTitle,
  AiSequenceChat,
  AiSequenceChatBody,
  AiSequenceChatHead,
  AiSequenceChatTrack,
  AiSequenceFlowBadge,
  AiSequenceFlowCap,
  AiSequenceFlowNode,
  AiSequenceFlowStep,
  AiSequenceLaunchBtn,
  AiSequenceMsg,
  AiSequenceScan,
  AiSequenceScanHead,
  AiSequenceScanLead,
  AiSequenceStage,
  AiSequenceTyping,
  AiSequenceWire,
  AiSequenceWires,
  LeadFinderAiButton,
  LeadFinderAvatar,
  LeadFinderBrand,
  LeadFinderCanvas,
  LeadFinderCaret,
  LeadFinderFilterHead,
  LeadFinderFilterPanel,
  LeadFinderFilterRow,
  LeadFinderHero,
  LeadFinderLeadMeta,
  LeadFinderLeadRow,
  LeadFinderMatch,
  LeadFinderMatchBar,
  LeadFinderPlaceholder,
  LeadFinderResults,
  LeadFinderResultsWrap,
  LeadFinderSearchField,
  LeadFinderSearchPanel,
  LeadFinderSearchRow,
  LeadFinderSearchText,
  LeadFinderStage,
  LeadFinderStatus,
  SceneAnalysisBeam,
  SceneAnalysisBody,
  SceneAnalysisCenter,
  SceneAnalysisCheck,
  SceneAnalysisConfidence,
  SceneAnalysisDomain,
  SceneAnalysisExtract,
  SceneAnalysisFieldItem,
  SceneAnalysisFieldLabel,
  SceneAnalysisFieldPh,
  SceneAnalysisFieldReveal,
  SceneAnalysisFields,
  SceneAnalysisFieldSlot,
  SceneAnalysisMainCard,
  SceneAnalysisMainFoot,
  SceneAnalysisMainHeader,
  SceneAnalysisLogo,
  SceneAnalysisPing,
  SceneAnalysisRow,
  SceneAnalysisScanDot,
  SceneAnalysisScanStatus,
  SceneAnalysisSite,
  SceneAnalysisSiteBar,
  SceneAnalysisSiteBody,
  SceneAnalysisSiteDot,
  SceneAnalysisSiteGrid,
  SceneAnalysisSiteUrl,
  SceneAnalysisSkCards,
  SceneAnalysisSkHero,
  SceneAnalysisSkLine,
  SceneAnalysisStep,
  SceneAnalysisSummaryLabel,
  SceneAnalysisSummaryWord,
  SceneAnalysisSummaryWords,
  SceneAnalysisSummaryWrap,
  SceneMotionWrap,
  SceneProgress,
  SceneProgressButton,
  SceneProgressFill,
  SceneProgressLabel,
  SceneProgressRow,
  SceneProgressTrack,
  SceneStage,
  ScenesContainer,
} from './ProductScenes.styles';

const SCENE_MS_DEFAULT = 6850;
const SCENE_MS_LEAD_FINDER = 7000;
const SCENE_MS_AI_SEQUENCE = 16000;
const SCENE_LABELS = ['Website Analysis', 'Lead Finder', 'AI Sequence'];

const ANALYSIS_FIELDS = [
  { label: 'Industry', value: 'B2B SaaS', delay: 1100 },
  { label: 'Stage', value: 'Series A', delay: 1450 },
  { label: 'ICP', value: 'Founders, GTM', delay: 1900 },
  { label: 'Offer', value: 'Outbound OS', delay: 2300 },
];

const ANALYSIS_PINGS = [
  { left: '34%', top: '46px', delay: 500 },
  { left: '80%', top: '78px', delay: 850 },
  { left: '24%', top: '150px', delay: 1600 },
  { left: '70%', top: '182px', delay: 2000 },
];

const ANALYSIS_SUMMARY_WORDS = [
  'Houdiny',
  'helps',
  'B2B',
  'teams',
  'launch',
  'outbound',
  'in',
  'minutes',
  '—',
  'pipeline-first,',
  'AI-personalized',
  'at',
  'scale.',
];

const ANALYSIS_HOLD_MS = 5900;
const ANALYSIS_EXIT_MS = 600;
const ANALYSIS_RESTART_MS = 350;

const AI_SEQUENCE_USER_TEXT = 'Build me a sequence for my ICP';

const AI_SEQUENCE_SCAN_LEADS = [
  { name: 'VP of Sales', pct: 98, initials: 'VS' },
  { name: 'Head of Growth', pct: 95, initials: 'HG' },
  { name: 'Demand Gen', pct: 92, initials: 'DG' },
];

const LEAD_FINDER_FILTERS = [
  { label: 'Job Titles', icon: IoPeopleOutline, chevron: true },
  { label: 'Location', icon: IoLocationOutline },
  { label: 'Industry', icon: IoBriefcaseOutline, chevron: true },
  { label: 'Keywords', icon: IoKeyOutline, chevron: true },
  { label: 'Employees', icon: IoPeopleOutline },
  { label: 'Revenue', icon: IoCashOutline },
];

const LEAD_FINDER_VARIATIONS = [
  {
    query: 'VP of Sales · B2B SaaS · 50–200 · US',

    count: 1284,

    leads: [
      { name: 'VP of Sales', co: 'Acme Cloud', m: 98, initials: 'VS' },

      { name: 'Head of Growth', co: 'Northwind Co', m: 95, initials: 'HG' },

      { name: 'Director, Demand Gen', co: 'Lumen Labs', m: 92, initials: 'DG' },
    ],
  },

  {
    query: 'Head of Marketing · Fintech · 200–500 · UK',

    count: 1947,

    leads: [
      { name: 'Head of Marketing', co: 'Monzo Pay', m: 97, initials: 'HM' },

      { name: 'VP, Demand Gen', co: 'Starling Co', m: 94, initials: 'VD' },

      { name: 'Growth Lead', co: 'Revolut Labs', m: 91, initials: 'GL' },
    ],
  },

  {
    query: 'Founder · AI Startups · 1–50 · Germany',

    count: 742,

    leads: [
      { name: 'Founder & CEO', co: 'Aleph AI', m: 98, initials: 'FC' },

      { name: 'Co-Founder', co: 'Nyx Labs', m: 96, initials: 'CF' },

      { name: 'Founder', co: 'Helsing Data', m: 93, initials: 'FO' },
    ],
  },
];

const wait = ms => new Promise(resolve => setTimeout(resolve, ms));

function getInitials(name) {
  return name

    .split(/[\s,&]+/)

    .filter(Boolean)

    .slice(0, 2)

    .map(part => part[0])

    .join('')

    .toUpperCase();
}

const SCENE_DESIGN = { width: 940, height: 570 };

function useSceneCanvasScale(stageRef, design = SCENE_DESIGN) {
  const [scale, setScale] = useState(0.52);

  useLayoutEffect(() => {
    const stage = stageRef.current;
    if (!stage) return undefined;

    const updateScale = () => {
      const { width, height } = stage.getBoundingClientRect();
      const scaleW = width / design.width;
      const scaleH = height / design.height;
      setScale(Math.min(scaleW, scaleH));
    };

    updateScale();
    const observer = new ResizeObserver(updateScale);
    observer.observe(stage);
    return () => observer.disconnect();
  }, [stageRef, design.width, design.height]);

  return scale;
}

function getBoxInCanvas(el, canvas) {
  let x = 0;
  let y = 0;
  let node = el;

  while (node && node !== canvas) {
    x += node.offsetLeft;
    y += node.offsetTop;
    node = node.offsetParent;
  }

  return { x, y, w: el.offsetWidth, h: el.offsetHeight };
}

function SceneAnalysis() {
  const cancelledRef = useRef(false);
  const stageRef = useRef(null);
  const canvasScale = useSceneCanvasScale(stageRef);

  const [screenVisible, setScreenVisible] = useState(false);
  const [scanActive, setScanActive] = useState(false);
  const [revealedFields, setRevealedFields] = useState([]);

  useEffect(() => {
    cancelledRef.current = false;

    const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

    const revealFields = async () => {
      setRevealedFields([]);
      let elapsed = 0;

      for (const field of ANALYSIS_FIELDS) {
        await wait(field.delay - elapsed);

        if (cancelledRef.current) return;

        elapsed = field.delay;
        setRevealedFields(current => [...current, field.label]);
      }
    };

    const runLoop = async () => {
      if (reducedMotion) {
        setScreenVisible(true);
        setScanActive(false);
        setRevealedFields(ANALYSIS_FIELDS.map(field => field.label));
        return;
      }

      await wait(350);

      while (!cancelledRef.current) {
        setScreenVisible(true);
        setScanActive(true);
        setRevealedFields([]);
        revealFields();

        await wait(ANALYSIS_HOLD_MS);

        if (cancelledRef.current) return;

        setScreenVisible(false);
        setScanActive(false);
        setRevealedFields([]);

        await wait(ANALYSIS_EXIT_MS);

        if (cancelledRef.current) return;

        await wait(ANALYSIS_RESTART_MS);
      }
    };

    runLoop();

    return () => {
      cancelledRef.current = true;
    };
  }, []);

  return (
    <LeadFinderStage ref={stageRef}>
      <LeadFinderCanvas $scale={canvasScale}>
        <SceneAnalysisCenter>
          <SceneAnalysisMainCard>
            <SceneAnalysisMainHeader $visible={screenVisible}>
              <SceneAnalysisLogo src={newLogoSm} alt="" />
              <div>
                <SceneAnalysisStep>
                  <span>Step 01</span> · Analyzing
                </SceneAnalysisStep>
                <SceneAnalysisDomain>houdiny.ai</SceneAnalysisDomain>
              </div>
            </SceneAnalysisMainHeader>

            <SceneAnalysisBody $visible={screenVisible}>
              <SceneAnalysisRow>
                <SceneAnalysisSite $visible={screenVisible}>
                  <SceneAnalysisSiteBar>
                    <SceneAnalysisSiteDot />
                    <SceneAnalysisSiteDot />
                    <SceneAnalysisSiteDot />
                    <SceneAnalysisSiteUrl>houdiny.ai</SceneAnalysisSiteUrl>
                  </SceneAnalysisSiteBar>

                  <SceneAnalysisSiteBody>
                    <SceneAnalysisSkHero />
                    <SceneAnalysisSkLine $width="85%" />
                    <SceneAnalysisSkLine $width="62%" />
                    <SceneAnalysisSkCards>
                      <span />
                      <span />
                    </SceneAnalysisSkCards>
                    {ANALYSIS_PINGS.map(ping => (
                      <SceneAnalysisPing
                        key={`${ping.left}-${ping.top}`}
                        $left={ping.left}
                        $top={ping.top}
                        $delay={ping.delay}
                        $active={scanActive}
                      />
                    ))}
                    <SceneAnalysisSiteGrid />
                    <SceneAnalysisBeam $active={scanActive} />
                  </SceneAnalysisSiteBody>
                </SceneAnalysisSite>

                <SceneAnalysisExtract>
                  <SceneAnalysisScanStatus $visible={screenVisible}>
                    <SceneAnalysisScanDot />
                    Scanning content, offers &amp; audience signals
                  </SceneAnalysisScanStatus>

                  <SceneAnalysisFields>
                    {ANALYSIS_FIELDS.map(field => (
                      <SceneAnalysisFieldItem key={field.label}>
                        <SceneAnalysisFieldLabel>{field.label}</SceneAnalysisFieldLabel>
                        <SceneAnalysisFieldSlot>
                          <SceneAnalysisFieldPh $hidden={revealedFields.includes(field.label)} />
                          <SceneAnalysisFieldReveal $revealed={revealedFields.includes(field.label)}>
                            {field.value}
                          </SceneAnalysisFieldReveal>
                        </SceneAnalysisFieldSlot>
                      </SceneAnalysisFieldItem>
                    ))}
                  </SceneAnalysisFields>

                  <SceneAnalysisSummaryWrap $visible={screenVisible}>
                    <SceneAnalysisSummaryLabel>AI Summary</SceneAnalysisSummaryLabel>
                    <SceneAnalysisSummaryWords>
                      {ANALYSIS_SUMMARY_WORDS.map((word, index) => (
                        <SceneAnalysisSummaryWord
                          key={`${word}-${index}`}
                          $active={screenVisible}
                          $delay={2900 + index * 55}
                        >
                          {word}
                        </SceneAnalysisSummaryWord>
                      ))}
                    </SceneAnalysisSummaryWords>
                  </SceneAnalysisSummaryWrap>
                </SceneAnalysisExtract>
              </SceneAnalysisRow>
            </SceneAnalysisBody>

            <SceneAnalysisMainFoot $visible={screenVisible}>
              <span>Analysis complete</span>
              <SceneAnalysisConfidence>
                <SceneAnalysisCheck>
                  <IoCheckmarkOutline />
                </SceneAnalysisCheck>
                98% confidence
              </SceneAnalysisConfidence>
            </SceneAnalysisMainFoot>
          </SceneAnalysisMainCard>
        </SceneAnalysisCenter>
      </LeadFinderCanvas>
    </LeadFinderStage>
  );
}

function SceneLeadFinder() {
  const cancelledRef = useRef(false);
  const stageRef = useRef(null);
  const canvasScale = useSceneCanvasScale(stageRef);

  const [searchText, setSearchText] = useState('');

  const [isEmpty, setIsEmpty] = useState(true);

  const [statusText, setStatusText] = useState('');

  const [statusVisible, setStatusVisible] = useState(false);

  const [btnPressed, setBtnPressed] = useState(false);

  const [leads, setLeads] = useState([]);

  const [visibleLeadCount, setVisibleLeadCount] = useState(0);

  const [resultsFading, setResultsFading] = useState(false);

  const [showCaret, setShowCaret] = useState(true);

  useEffect(() => {
    cancelledRef.current = false;

    const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

    const typeInto = async text => {
      setIsEmpty(false);

      setSearchText('');

      for (let i = 0; i < text.length; i += 1) {
        if (cancelledRef.current) return;

        setSearchText(text.slice(0, i + 1));

        await wait(text[i] === ' ' ? 70 : 40);
      }
    };

    const countUp = async target => {
      const start = performance.now();

      const duration = 600;

      return new Promise(resolve => {
        const tick = now => {
          if (cancelledRef.current) {
            resolve();

            return;
          }

          const progress = Math.min(1, (now - start) / duration);

          setStatusText(`${Math.round(progress * target).toLocaleString()} matched leads`);

          if (progress < 1) {
            requestAnimationFrame(tick);
          } else {
            resolve();
          }
        };

        requestAnimationFrame(tick);
      });
    };

    const runLoop = async () => {
      if (reducedMotion) {
        const variation = LEAD_FINDER_VARIATIONS[0];

        setIsEmpty(false);

        setSearchText(variation.query);

        setLeads(variation.leads);

        setVisibleLeadCount(variation.leads.length);

        setStatusText(`${variation.count.toLocaleString()} matched leads`);

        setStatusVisible(true);

        setShowCaret(false);

        return;
      }

      let variationIndex = 0;

      while (!cancelledRef.current) {
        const variation = LEAD_FINDER_VARIATIONS[variationIndex];

        variationIndex = (variationIndex + 1) % LEAD_FINDER_VARIATIONS.length;

        setIsEmpty(true);

        setSearchText('');

        setLeads([]);

        setVisibleLeadCount(0);

        setResultsFading(false);

        setStatusVisible(false);

        setShowCaret(true);

        await wait(950);

        if (cancelledRef.current) return;

        await typeInto(variation.query);

        if (cancelledRef.current) return;

        await wait(340);

        setBtnPressed(true);

        setTimeout(() => setBtnPressed(false), 240);

        setStatusText('Searching…');

        setStatusVisible(true);

        await wait(640);

        if (cancelledRef.current) return;

        setLeads(variation.leads);

        for (let i = 0; i < variation.leads.length; i += 1) {
          await wait(225);

          if (cancelledRef.current) return;

          setVisibleLeadCount(i + 1);
        }

        await wait(220);

        if (cancelledRef.current) return;

        await countUp(variation.count);

        await wait(2900);

        if (cancelledRef.current) return;

        setResultsFading(true);

        setStatusVisible(false);

        await wait(560);

        if (cancelledRef.current) return;

        setLeads([]);

        setVisibleLeadCount(0);
      }
    };

    runLoop();

    return () => {
      cancelledRef.current = true;
    };
  }, []);

  return (
    <LeadFinderStage ref={stageRef}>
      <LeadFinderCanvas $scale={canvasScale}>
        <LeadFinderFilterPanel>
          <LeadFinderBrand>
            <img src={newLogoSm} alt="" />
            Lead Finder
          </LeadFinderBrand>

          <LeadFinderFilterHead>
            <strong>Filters</strong>

            <div>
              <span>Save</span>

              <span>Load</span>
            </div>
          </LeadFinderFilterHead>

          {LEAD_FINDER_FILTERS.map(filter => (
            <LeadFinderFilterRow key={filter.label}>
              <filter.icon />

              <span>{filter.label}</span>

              {filter.chevron ? <IoChevronDownOutline style={{ width: 16, height: 16, opacity: 0.35 }} /> : null}
            </LeadFinderFilterRow>
          ))}
        </LeadFinderFilterPanel>

        <LeadFinderSearchPanel>
          <LeadFinderHero>
            Let <span>Houdiny AI</span> find your best leads
          </LeadFinderHero>

          <LeadFinderSearchRow>
            <LeadFinderSearchField>
              <IoSearchOutline />

              <LeadFinderPlaceholder $hidden={!isEmpty}>Describe your ideal customer…</LeadFinderPlaceholder>

              <LeadFinderSearchText>{searchText}</LeadFinderSearchText>

              {showCaret ? <LeadFinderCaret /> : null}
            </LeadFinderSearchField>

            <LeadFinderAiButton type="button" $pressed={btnPressed}>
              <IoSearchOutline />
              AI Search
            </LeadFinderAiButton>
          </LeadFinderSearchRow>

          <LeadFinderStatus $visible={statusVisible}>
            <span />

            {statusText}
          </LeadFinderStatus>

          <LeadFinderResultsWrap>
            <LeadFinderResults $fading={resultsFading}>
              {leads.map((lead, index) => (
                <LeadFinderLeadRow key={`${lead.name}-${lead.co}`} $visible={index < visibleLeadCount}>
                  <LeadFinderAvatar>{lead.initials || getInitials(lead.name)}</LeadFinderAvatar>

                  <LeadFinderLeadMeta>
                    <strong>{lead.name}</strong>

                    <span>{lead.co}</span>
                  </LeadFinderLeadMeta>

                  <LeadFinderMatch>
                    <strong>{lead.m}%</strong>

                    <LeadFinderMatchBar $width={index < visibleLeadCount ? lead.m : 0}>
                      <i />
                    </LeadFinderMatchBar>
                  </LeadFinderMatch>
                </LeadFinderLeadRow>
              ))}
            </LeadFinderResults>
          </LeadFinderResultsWrap>
        </LeadFinderSearchPanel>
      </LeadFinderCanvas>
    </LeadFinderStage>
  );
}

function countToValue(setter, target, duration, suffix = '') {
  return new Promise(resolve => {
    const start = performance.now();

    const tick = now => {
      const progress = Math.min(1, (now - start) / duration);
      const eased = 1 - (1 - progress) ** 3;
      setter(`${Math.round(eased * target).toLocaleString()}${suffix}`);

      if (progress < 1) {
        requestAnimationFrame(tick);
      } else {
        resolve();
      }
    };

    requestAnimationFrame(tick);
  });
}

function SceneAiSequence() {
  const cancelledRef = useRef(false);
  const stageRef = useRef(null);
  const canvasRef = useRef(null);
  const canvasScale = useSceneCanvasScale(stageRef);
  const bodyRef = useRef(null);
  const trackRef = useRef(null);
  const triggerNodeRef = useRef(null);
  const emailNodeRef = useRef(null);
  const liNodeRef = useRef(null);
  const cfgRef = useRef(null);

  const [trackOffset, setTrackOffset] = useState(0);
  const [msgs, setMsgs] = useState({
    a1: false,
    u1: false,
    typing: false,
    a2: false,
    found: false,
    build: false,
    live: false,
  });
  const [userText, setUserText] = useState('');
  const [showCaret, setShowCaret] = useState(false);
  const [leadCount, setLeadCount] = useState('0');
  const [scanLeads, setScanLeads] = useState(
    AI_SEQUENCE_SCAN_LEADS.map(lead => ({ ...lead, visible: false, pctDisplay: '0%' })),
  );
  const [steps, setSteps] = useState({ trigger: false, email: false, li: false });
  const [stepState, setStepState] = useState({ trigger: {}, email: {}, li: {} });
  const [cfgVisible, setCfgVisible] = useState(false);
  const [canvasFading, setCanvasFading] = useState(false);
  const [chatFading, setChatFading] = useState(false);
  const [activeTab, setActiveTab] = useState('setup');
  const [channel, setChannel] = useState({
    name: 'Email outreach',
    action: 'AI-personalized message',
    iconBg: 'var(--onboarding-brand-gradient)',
    linkedIn: false,
  });
  const [launchPressed, setLaunchPressed] = useState(false);
  const [launchLive, setLaunchLive] = useState(false);
  const [launchText, setLaunchText] = useState('Launch campaign');
  const [wires, setWires] = useState({ cfg: false, email: false, li: false });
  const [wirePaths, setWirePaths] = useState({ cfg: '', email: '', li: '' });

  const settle = useCallback(() => {
    if (!trackRef.current || !bodyRef.current) return;
    const overflow = trackRef.current.scrollHeight - bodyRef.current.clientHeight;
    setTrackOffset(overflow > 0 ? -(overflow + 12) : 0);
  }, []);

  const setWirePath = useCallback((fromEl, toEl, mode) => {
    const canvas = canvasRef.current;
    if (!canvas || !fromEl || !toEl) return '';

    const a = getBoxInCanvas(fromEl, canvas);
    const b = getBoxInCanvas(toEl, canvas);

    if (mode === 'down') {
      const x1 = a.x + a.w / 2;
      const y1 = a.y + a.h;
      const x2 = b.x + b.w / 2;
      const y2 = b.y;
      const my = (y1 + y2) / 2;
      return `M${x1} ${y1} C${x1} ${my} ${x2} ${my} ${x2} ${y2}`;
    }

    const x1 = a.x + a.w;
    const y1 = a.y + a.h / 2;
    const x2 = b.x;
    const y2 = b.y + Math.min(b.h / 2, 92);
    const mx = (x1 + x2) / 2;
    return `M${x1} ${y1} C${mx} ${y1} ${mx} ${y2} ${x2} ${y2}`;
  }, []);

  const updateWirePaths = useCallback(() => {
    const next = { cfg: '', email: '', li: '' };

    if (wires.cfg && triggerNodeRef.current && cfgRef.current) {
      next.cfg = setWirePath(triggerNodeRef.current, cfgRef.current, 'right');
    }
    if (wires.email && triggerNodeRef.current && emailNodeRef.current) {
      next.email = setWirePath(triggerNodeRef.current, emailNodeRef.current, 'down');
    }
    if (wires.li && triggerNodeRef.current && liNodeRef.current) {
      next.li = setWirePath(triggerNodeRef.current, liNodeRef.current, 'down');
    }

    setWirePaths(next);
  }, [setWirePath, wires.cfg, wires.email, wires.li]);

  useLayoutEffect(() => {
    updateWirePaths();
  }, [updateWirePaths, steps, cfgVisible, canvasScale]);

  useEffect(() => {
    cancelledRef.current = false;

    const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

    const reset = () => {
      setMsgs({ a1: false, u1: false, typing: false, a2: false, found: false, build: false, live: false });
      setUserText('');
      setShowCaret(false);
      setLeadCount('0');
      setScanLeads(AI_SEQUENCE_SCAN_LEADS.map(lead => ({ ...lead, visible: false, pctDisplay: '0%' })));
      setTrackOffset(0);
      setSteps({ trigger: false, email: false, li: false });
      setStepState({ trigger: {}, email: {}, li: {} });
      setCfgVisible(false);
      setCanvasFading(false);
      setChatFading(false);
      setActiveTab('setup');
      setChannel({
        name: 'Email outreach',
        action: 'AI-personalized message',
        iconBg: 'var(--onboarding-brand-gradient)',
        linkedIn: false,
      });
      setLaunchPressed(false);
      setLaunchLive(false);
      setLaunchText('Launch campaign');
      setWires({ cfg: false, email: false, li: false });
      setWirePaths({ cfg: '', email: '', li: '' });
    };

    const runLoop = async () => {
      if (reducedMotion) {
        setMsgs({ a1: true, u1: true, typing: false, a2: true, found: true, build: true, live: true });
        setUserText(AI_SEQUENCE_USER_TEXT);
        setLeadCount('1,284');
        setScanLeads(AI_SEQUENCE_SCAN_LEADS.map(lead => ({ ...lead, visible: true, pctDisplay: `${lead.pct}%` })));
        setSteps({ trigger: true, email: true, li: true });
        setStepState({ trigger: { live: true }, email: { live: true }, li: { live: true } });
        setCfgVisible(true);
        setActiveTab('launch');
        setLaunchLive(true);
        setLaunchText('Campaign live');
        setWires({ cfg: true, email: true, li: true });
        requestAnimationFrame(settle);
        return;
      }

      while (!cancelledRef.current) {
        reset();
        await wait(650);
        if (cancelledRef.current) return;

        setMsgs(prev => ({ ...prev, a1: true }));
        requestAnimationFrame(settle);
        await wait(850);

        setMsgs(prev => ({ ...prev, u1: true }));
        setShowCaret(true);
        requestAnimationFrame(settle);
        await wait(320);

        for (let i = 0; i < AI_SEQUENCE_USER_TEXT.length; i += 1) {
          if (cancelledRef.current) return;
          setUserText(AI_SEQUENCE_USER_TEXT.slice(0, i + 1));
          requestAnimationFrame(settle);
          await wait(36);
        }

        await wait(380);
        setShowCaret(false);
        await wait(160);

        setMsgs(prev => ({ ...prev, typing: true }));
        requestAnimationFrame(settle);
        await wait(1050);
        setMsgs(prev => ({ ...prev, typing: false }));
        await wait(110);

        setMsgs(prev => ({ ...prev, a2: true }));
        requestAnimationFrame(settle);
        await wait(780);

        setMsgs(prev => ({ ...prev, found: true }));
        requestAnimationFrame(settle);
        await countToValue(setLeadCount, 1284, 850);
        await wait(200);

        for (let i = 0; i < AI_SEQUENCE_SCAN_LEADS.length; i += 1) {
          if (cancelledRef.current) return;
          const lead = AI_SEQUENCE_SCAN_LEADS[i];
          setScanLeads(prev =>
            prev.map((item, index) => (index === i ? { ...item, visible: true, pctDisplay: `${lead.pct}%` } : item)),
          );
          requestAnimationFrame(settle);
          await wait(400);
        }

        await wait(560);
        setMsgs(prev => ({ ...prev, build: true }));
        requestAnimationFrame(settle);
        await wait(720);

        setSteps(prev => ({ ...prev, trigger: true }));
        await wait(330);
        setWires(prev => ({ ...prev, cfg: true }));
        setCfgVisible(true);
        await wait(500);

        setWires(prev => ({ ...prev, email: true }));
        setSteps(prev => ({ ...prev, email: true }));
        await wait(430);

        setWires(prev => ({ ...prev, li: true }));
        setSteps(prev => ({ ...prev, li: true }));
        await wait(540);

        setActiveTab('setup');
        setStepState({ trigger: {}, email: { active: true }, li: {} });
        setChannel({
          name: 'Email outreach',
          action: 'AI-personalized message',
          iconBg: 'var(--onboarding-brand-gradient)',
          linkedIn: false,
        });
        await wait(1250);

        setStepState({ trigger: {}, email: {}, li: { active: true } });
        setChannel({
          name: 'LinkedIn DM',
          action: 'Auto connect + message',
          iconBg: '#0A66C2',
          linkedIn: true,
        });
        await wait(1250);

        setStepState({ trigger: {}, email: {}, li: {} });
        setActiveTab('launch');
        setLaunchPressed(true);
        await wait(220);
        setLaunchPressed(false);
        setLaunchLive(true);
        setLaunchText('Campaign live');
        setStepState({ trigger: { live: true }, email: { live: true }, li: { live: true } });
        await wait(280);

        setMsgs(prev => ({ ...prev, live: true }));
        requestAnimationFrame(settle);
        await wait(3100);

        setChatFading(true);
        setCanvasFading(true);
        await wait(640);
      }
    };

    runLoop();

    return () => {
      cancelledRef.current = true;
    };
  }, [settle]);

  return (
    <AiSequenceStage ref={stageRef}>
      <AiSequenceCanvas ref={canvasRef} $scale={canvasScale}>
        <AiSequenceWires viewBox="0 0 940 470" preserveAspectRatio="none">
          <defs>
            <linearGradient id="aiSeqWireGrad" x1="0" y1="0" x2="1" y2="0">
              <stop offset="0" stopColor="#2580F3" />
              <stop offset="1" stopColor="#B74BFF" />
            </linearGradient>
          </defs>
          <AiSequenceWire d={wirePaths.cfg} $drawn={wires.cfg && Boolean(wirePaths.cfg)} />
          <AiSequenceWire d={wirePaths.email} $drawn={wires.email && Boolean(wirePaths.email)} />
          <AiSequenceWire d={wirePaths.li} $drawn={wires.li && Boolean(wirePaths.li)} />
        </AiSequenceWires>

        <AiSequenceChat $fading={chatFading}>
          <AiSequenceChatHead>
            <img src={newLogoSm} alt="" />
            <div>
              <strong>Houdiny AI</strong>
              <span>
                <i /> Your AI sales agent
              </span>
            </div>
            <em>···</em>
          </AiSequenceChatHead>

          <AiSequenceChatBody ref={bodyRef}>
            <AiSequenceChatTrack ref={trackRef} $offset={trackOffset}>
              <AiSequenceMsg $visible={msgs.a1}>
                <AiSequenceAvatar>
                  <img src={newLogoSm} alt="" />
                </AiSequenceAvatar>
                <AiSequenceBubble>Hey, what can I do for you today?</AiSequenceBubble>
              </AiSequenceMsg>

              <AiSequenceMsg $visible={msgs.u1} $me>
                <AiSequenceBubble $me>
                  {userText}
                  {showCaret ? <AiSequenceCaret /> : null}
                </AiSequenceBubble>
              </AiSequenceMsg>

              <AiSequenceMsg $visible={msgs.typing}>
                <AiSequenceAvatar>
                  <img src={newLogoSm} alt="" />
                </AiSequenceAvatar>
                <AiSequenceBubble>
                  <AiSequenceTyping>
                    <i />
                    <i />
                    <i />
                  </AiSequenceTyping>
                </AiSequenceBubble>
              </AiSequenceMsg>

              <AiSequenceMsg $visible={msgs.a2}>
                <AiSequenceAvatar>
                  <img src={newLogoSm} alt="" />
                </AiSequenceAvatar>
                <AiSequenceBubble>On it boss, finding your best-fit leads…</AiSequenceBubble>
              </AiSequenceMsg>

              <AiSequenceMsg $visible={msgs.found}>
                <AiSequenceAvatar>
                  <img src={newLogoSm} alt="" />
                </AiSequenceAvatar>
                <AiSequenceBubble>
                  <AiSequenceScan>
                    <AiSequenceScanHead>
                      <i />
                      <span>
                        <b>{leadCount}</b> leads · <b>312</b> high-intent
                      </span>
                    </AiSequenceScanHead>
                    {scanLeads.map(lead => (
                      <AiSequenceScanLead key={lead.name} $visible={lead.visible} $pct={lead.visible ? lead.pct : 0}>
                        <span>{lead.initials}</span>
                        <span className="nm">{lead.name}</span>
                        <span className="bar">
                          <i />
                        </span>
                        <span className="pc">{lead.pctDisplay}</span>
                      </AiSequenceScanLead>
                    ))}
                  </AiSequenceScan>
                </AiSequenceBubble>
              </AiSequenceMsg>

              <AiSequenceMsg $visible={msgs.build}>
                <AiSequenceAvatar>
                  <img src={newLogoSm} alt="" />
                </AiSequenceAvatar>
                <AiSequenceBubble>Sequence ready, wiring up your campaign →</AiSequenceBubble>
              </AiSequenceMsg>

              <AiSequenceMsg $visible={msgs.live}>
                <AiSequenceAvatar>
                  <img src={newLogoSm} alt="" />
                </AiSequenceAvatar>
                <AiSequenceBubble>It&apos;s live, ready to start</AiSequenceBubble>
              </AiSequenceMsg>
            </AiSequenceChatTrack>
          </AiSequenceChatBody>
        </AiSequenceChat>

        <AiSequenceFlowStep $left="481px" $top="115px" $visible={steps.trigger} $fading={canvasFading}>
          <AiSequenceFlowNode ref={triggerNodeRef} $active={false} $live={stepState.trigger?.live}>
            <span className="dots">···</span>
            <span className="bolt">
              <IoFlashOutline />
            </span>
          </AiSequenceFlowNode>
          <AiSequenceFlowCap $bottom>New lead</AiSequenceFlowCap>
        </AiSequenceFlowStep>

        <AiSequenceFlowStep $left="412px" $top="289px" $visible={steps.email} $fading={canvasFading}>
          <AiSequenceFlowBadge $live={stepState.email?.live}>
            <IoCheckmarkOutline />
          </AiSequenceFlowBadge>
          <AiSequenceFlowNode ref={emailNodeRef} $active={stepState.email?.active} $live={stepState.email?.live}>
            <span className="bolt">
              <IoMailOutline />
            </span>
          </AiSequenceFlowNode>
          <AiSequenceFlowCap>AI Email</AiSequenceFlowCap>
        </AiSequenceFlowStep>

        <AiSequenceFlowStep $left="550px" $top="289px" $visible={steps.li} $fading={canvasFading}>
          <AiSequenceFlowBadge $live={stepState.li?.live}>
            <IoCheckmarkOutline />
          </AiSequenceFlowBadge>
          <AiSequenceFlowNode
            ref={liNodeRef}
            $color="#0A66C2"
            $active={stepState.li?.active}
            $live={stepState.li?.live}>
            <span className="bolt" style={{ fontWeight: 800, fontSize: 16, letterSpacing: '-0.5px' }}>
              in
            </span>
          </AiSequenceFlowNode>
          <AiSequenceFlowCap>LinkedIn DM</AiSequenceFlowCap>
        </AiSequenceFlowStep>

        <AiSequenceCfg ref={cfgRef} $visible={cfgVisible} $fading={canvasFading}>
          <AiSequenceCfgTitle>
            New campaign <span>×</span>
          </AiSequenceCfgTitle>
          <AiSequenceCfgTabs>
            <AiSequenceCfgTab $active={activeTab === 'setup'}>Setup</AiSequenceCfgTab>
            <AiSequenceCfgTab $active={activeTab === 'seq'}>Sequence</AiSequenceCfgTab>
            <AiSequenceCfgTab $active={activeTab === 'launch'}>Launch</AiSequenceCfgTab>
          </AiSequenceCfgTabs>
          <AiSequenceCfgLabel>Channel</AiSequenceCfgLabel>
          <AiSequenceCfgField $iconBg={channel.iconBg}>
            <span className="ci">
              {channel.linkedIn ? <span style={{ fontWeight: 800, fontSize: 8 }}>in</span> : <IoMailOutline />}
            </span>
            <span className="cv">{channel.name}</span>
            <IoChevronDownOutline className="chev" />
          </AiSequenceCfgField>
          <AiSequenceCfgLabel>Action</AiSequenceCfgLabel>
          <AiSequenceCfgField>
            <span className="cv">{channel.action}</span>
            <IoChevronDownOutline className="chev" />
          </AiSequenceCfgField>
          <AiSequenceCfgLabel>Audience</AiSequenceCfgLabel>
          <AiSequenceCfgField>
            <span className="cv">312 high-intent · ICP</span>
            <IoChevronDownOutline className="chev" />
          </AiSequenceCfgField>
          <AiSequenceLaunchBtn type="button" $pressed={launchPressed} $live={launchLive}>
            {launchText}
          </AiSequenceLaunchBtn>
        </AiSequenceCfg>
      </AiSequenceCanvas>
    </AiSequenceStage>
  );
}

const SCENES = [SceneAnalysis, SceneLeadFinder, SceneAiSequence];

const SCENE_DURATIONS = [SCENE_MS_DEFAULT, SCENE_MS_LEAD_FINDER, SCENE_MS_AI_SEQUENCE];

function ProductScenes() {
  const [activeIndex, setActiveIndex] = useState(0);

  const [progress, setProgress] = useState(0);

  useEffect(() => {
    setProgress(0);

    const start = Date.now();

    const duration = SCENE_DURATIONS[activeIndex];

    const progressTimer = setInterval(() => {
      const elapsed = Date.now() - start;

      setProgress(Math.min(100, (elapsed / duration) * 100));
    }, 50);

    const sceneTimer = setTimeout(() => {
      setActiveIndex(current => (current + 1) % SCENES.length);
    }, duration);

    return () => {
      clearInterval(progressTimer);

      clearTimeout(sceneTimer);
    };
  }, [activeIndex]);

  const ActiveScene = SCENES[activeIndex];

  return (
    <ScenesContainer>
      <SceneStage>
        <SceneMotionWrap key={activeIndex}>
          <ActiveScene />
        </SceneMotionWrap>
      </SceneStage>

      <SceneProgress>
        <SceneProgressRow>
          {SCENE_LABELS.map((label, index) => {
            const isActive = index === activeIndex;

            const isPast = index < activeIndex;

            return (
              <SceneProgressButton key={label} type="button" onClick={() => setActiveIndex(index)} aria-label={label}>
                <SceneProgressTrack>
                  <SceneProgressFill style={{ width: isActive ? `${progress}%` : isPast ? '100%' : '0%' }} />
                </SceneProgressTrack>

                <SceneProgressLabel $active={isActive}>{label}</SceneProgressLabel>
              </SceneProgressButton>
            );
          })}
        </SceneProgressRow>
      </SceneProgress>
    </ScenesContainer>
  );
}

export default ProductScenes;
